<template>
  <div>
    <SysPam></SysPam>
  </div>
</template>

<script>
import SysPam from '../components/SystemParam.vue';

export default {
  components: {
    SysPam,
  },
};
</script>
